import { ABTestFeatures, ABTestType } from './ABTestFeatures';
/**
 * Checks if an A/B feature is enabled.
 *
 * @returns True if the feature is enabled.
 */
export const checkIsFeatureEnabled = ({ name, variation, activeExperiment, getOverrides }) => {
    const testType = ABTestFeatures[name];
    if (testType == null) {
        throw new Error(`Feature "${name}" is not defined in ABTestFeatures`);
    }
    const isABTest = testType === ABTestType.AB;
    if (!isABTest && !variation) {
        throw new Error('Tests with more than two variations require the "variation" parameter to be specified');
    }
    // Future TODO: explore removing this limitation, variations of 'A' | 'B' could work
    //   but we'd have to figure out how to handle it if the validation & enable flags contradict each other
    if (isABTest && variation) {
        throw new Error('It is not supported to specify a variation for a simple AB test');
    }
    const overrides = getOverrides({ name, variation });
    if (overrides.forceDisable) {
        return false;
    }
    if (overrides.forceEnable) {
        return true;
    }
    if (activeExperiment?.name !== name) {
        return false;
    }
    if (isABTest) {
        return activeExperiment.variation === 'B'; // 'A' is the control group, so features are enabled for B
    }
    return activeExperiment.variation === variation;
};
//# sourceMappingURL=checkIsFeatureEnabled.js.map